import {Directive,inject} from '@angular/core';
import {NgControl} from '@angular/forms';

@Directive({
	selector:'[appInputTrim]',
	host:{
		'(blur)':'onEvent($event)'
	}
})
export class InputTrimDirective{
	private readonly ngControl=inject(NgControl);

	onEvent(event:Event):void{
		const target=event.target as HTMLInputElement;
		this.ngControl.control!.setValue(target.value.trim());
	}
}
